import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import { Questionnaire } from '../../model/questionnaire';
import { Project } from '../../model/project';
import { Question } from '../../model/question';
import { Choice } from '../../model/choice';
import { ProjectService } from '../project.service';
import { Constants } from '../../model/constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import {MaterialChipsInputComponent} from '../tags/materialChipsInput.component';
import {FileChooserComponent} from '../../FileChooser/file-chooser.component';
import {ImportDuplicateModalComponent} from '../../import-duplicate-modal/import-duplicate-modal.component';
import {CurrentContext} from '../../model/currentContext';
import {CreateQuestionnaireComponent} from '../createQuestionnaire/create-questionnaire.component';
import {Terminal} from '../../model/terminal';
import {CreateQuestionComponent} from '../createQuestion/create-question.component';
import {CreateChoiceComponent} from '../createChoice/create-choice.component';
import {StatusMsg} from '../../model/status/StatusMsg';
import {SharedRefreshService} from '../../service/sharedRefreshService';
import {PurgeModel} from '../../model/Purge/purgeModel';
import {ValidationService} from '../../service/validation-service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as moment from '../../dynamicDataFilter/dynamic-data-filter.component';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';
import {StringUtil} from '../../util/stringUtil';

@Component({
    selector : 'questionnaire-view',
    template: `
      <!--<div class="panel panel-default" style="margin-left:15px;margin-right:15px;">
        <div class="row">-->
          <div class="col card" style="padding: 10px;">
            <!--<div class="card-body">-->
              <div class="w3-card-4">
                <header class="w3-container" style="background:linear-gradient(0deg,rgba(59,139,239,1) 0%,rgba(11,97,206,1) 100%);border-top-left-radius:5px;border-top-right-radius:5px;">
                  <h4><span><img  alt="icon" *ngIf="!this.project.webProject" style="height:40px;width:40px;" src="../../../assets/images/041.png">
                  <img alt="icon" *ngIf="this.project.webProject" style="height:50px;" src="../../../assets/images/1149.png"></span>{{questionnaire.name}}</h4>
                  <div class="w3-padding w3-xlarge w3-text-white">
                    <div style="float:right;">
                      <button type="button" class="btn btn-primary btn-lg" (click)="onImport($event)" value="project" data-toggle="tooltip" data-placement="bottom" title="Import Terminal" style="margin-right:3px"><img  alt="icon" class="titleBarIcon" src="../../../assets/images/147.png"></button>
                      <button type="button" class="btn btn-primary btn-lg" (click)="addTerminal()" data-toggle="tooltip" data-placement="bottom" title="Add terminal"><img  alt="icon" class="titleBarIcon" src="../../../assets/images/65.png"></button>
                    </div>
                    <div>
                      <button type="button" class="btn btn-danger btn-lg" (click)="removeQuestionnaire()" data-toggle="tooltip" data-placement="bottom" title="Delete Questionnaire"><img  alt="icon" class="titleBarIcon" src="../../../assets/images/trash.png"></button>
                    </div>
                  </div>
                </header>
                <div class="w3-container">
                  <breadcrumb [path]="generateBreadCrumb()" (breadCrumbLink)="onBreadCrumbLink($event)"></breadcrumb>
                  <div>
                    <span><img class="mainLogoIcon" src="../../../assets/images/googleForm.png" alt="Questionnaire"></span>
                  </div>
                  <div class="card cardForm" style="margin-right:15px;margin-left:15px;">
                      <h5 class="card-header"><span><img class="titleBar" src="../../../assets/images/ToolbarAdvanced.png"></span>Purge Configuration</h5>
                      <div class="card-body">
                        <div>
                            <form [formGroup]=this.purgeForm>
                                <label class="bold">Purge Date Range</label>
                                <table>
                                    <tr>
                                        <td><label class="bold">Start Date</label></td>
                                        <td><ejs-datepicker id='datepicker' formControlName="startDate" placeholder='Select a date' [value]='startDateValue' [min]='minDate' [max]='maxDate' (change)="startDateChanged($event)"></ejs-datepicker></td>
                                    </tr>
                                    <tr>
                                        <td><label class="bold">End Date</label></td>
                                        <td><ejs-datepicker id='datepicker' formControlName="endDate" placeholder='Select a date' [value]='endDateValue' [min]='minDate' [max]='maxDate' (change)="endDateChanged($event)"></ejs-datepicker></td>
                                    </tr>
                                </table>
                                <table>
                                    <tr><td><Label class="bold">Use Date Range</Label></td><td><input formControlName="useDateRange" type="checkbox"></td></tr>
                                    <tr style="border-style: dashed;border-width: thin;border-color: #1c71ff;"><td><Label class="bold">Purge Cycle</Label></td><td><input type="text" formControlName="purgePeriod" placeholder="eg:24"></td><td><p>Select a unit for the purge cycle:</p>
                                        <input type="radio" id="hours" name="unit" formControlName="unit" [checked]="purgeForm.controls.unit.value === 'hours'" value="hours">
                                        <label for="male">Hours</label><br>
                                        <input type="radio" id="minutes" name="unit" formControlName="unit" [checked]="purgeForm.controls.unit.value === 'minutes'" value="minutes">
                                        <label for="female">Minutes</label><br>
                                        <input type="radio" id="seconds" name="unit" formControlName="unit" [checked]="purgeForm.controls.unit.value === 'seconds'" value="seconds">
                                        <label for="other">Seconds</label><br>
                                        <input type="radio" id="days" name="unit" formControlName="unit" [checked]="purgeForm.controls.unit.value === 'days'" value="days">
                                        <label for="other">Days</label></td></tr>
                                </table>
                                <table>
                                    <tr>
                                           <div class="tagsbox row top-buffer col-md-6">
                                               <ng-container *ngIf="purgeModel!=null">
                                                <h3 style="margin-left:15px;margin-top:10px;float:left;" *ngFor="let key of purgeModel.keys"><span class="badge badge-secondary">{{key}}<span style="margin-left: 5px;" (click)="removeKey(key)"><i style="color: red; font-size: 20px;" class="far fa-times-circle"></i></span></span></h3>
                                               </ng-container>
                                           </div>
                                    </tr>
                                    <tr>
                                            <div class="col-md-6 input-group mb-4" style="float:left;margin-top:10px;">
                                                <input type="text" class="form-control" placeholder="eg:cb_14,tempo" aria-label="Tags" aria-describedby="button-addon2" formControlName="key">
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" (click)="addKey()">Add Key</button>
                                                </div>
                                            </div>
                                    </tr>
                                </table>
                                <table>
                                    <tr><td><Label class="bold">UEI</Label></td><td><input type="text" formControlName="uei" placeholder="eg:jpo908jui"></td></tr>
                                </table>
                                <table>
                                    <tr><td><Label class="bold">Extract List of Deleted Files</Label></td><td><input formControlName="extractListOfDeletedFiles" type="checkbox"></td></tr>
                                </table>
                            </form>
                        </div>
                        <button  style="float:right;margin-right:5px;" class="btn btn-success btn-md" (click)="enableCronJob()" data-toggle="tooltip" data-placement="bottom" title="Run cron job on this questionnaire and all related entities">Enable CRON JOB</button>
                        <button style="float:right;" class="btn btn-danger btn-md" (click)="disableCronJob()" data-toggle="tooltip" data-placement="bottom" title="Remove any cron job on this questionnaire and all related entities">Disable CRON JOB</button>
                      </div>
                  </div>
                  <div class="card cardForm" style="margin-right:15px;margin-left:15px;">
                    <h5 class="card-header"><span><img class="titleBar" src="../../../assets/images/251.png"></span>Properties</h5>
                    <div class="card-body">
                      <div>
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon3">ID</span>
                          </div>
                            <input readonly  type="text" class="form-control"  id="basic-id" aria-describedby="basic-addon3" [(ngModel)]="questionnaire.id"/>
                        </div>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon3">{{'title'|translate}}</span>
                            </div>
                            <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" [(ngModel)]="questionnaire.name">
                        </div>

                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon3">{{'Created Date'|translate}}</span>
                          </div>
                          <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" [(ngModel)]="questionnaire.createdDate">
                        </div>

                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon3">{{'Last Modified Date'|translate}}</span>
                          </div>
                          <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" [(ngModel)]="questionnaire.lastModifiedDate">
                        </div>

                          <div class="input-group mb-3">
                              <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon3">Class Loader Name</span>
                              </div>
                              <input type="text" name="loaderClass" class="form-control"  [(ngModel)]="questionnaire.loaderClass" required/>
                          </div>


                          <div class="">
                              <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon3">Full Screen</span>
                                  <input type="checkbox" style="margin-left:57px;width:20px;" name="fullScreen" class="form-control" [checked]="isChecked()"  [(ngModel)]="questionnaire.fullScreen" required/>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="card cardForm" style="margin-right:15px;margin-left:15px;">
                        <h5 class="card-header"><span><img alt="languages" class="titleBar" src="../../../assets/images/276.png"></span>Supported Languages</h5>
                        <div class="card-body">
                            <div class="ContentSection col-md-12">
                                <div class="mat-app-background basic-container">
                                    <material-chips-input (reload)="switchQuestionLanguage($event)" (langAdded)="langAdded($event)">loading</material-chips-input>
                                    <p *ngIf="this._selectedLanguage==null || this._selectedLanguage.length===0" class="alert"><span class="exclamation"><i class="fas fa-exclamation-circle"></i></span>Define and select a language before defining your content.</p>
                                </div>
                            </div>
                        </div>
                  </div>

                  <div class="card cardForm" style="margin-right:15px;margin-left:15px;">
                      <h5 class="card-header"><span><img alt="icon" class="titleBar" src="../../../assets/images/352.png"></span>Questions</h5>
                      <div class="card-body ">
                <div class="col-md-12 form-group questionnaireFunction">
                  <div class="col-md-12">
                    <div class="row top-buffer">
                      <div class="col-md-4">
                        <button #aEle  (click)="onNewQuestion()" type="button" class="btn btn-primary">
                          <span style="font-size: 18px;margin-right: 10px;"><i class="fas fa-plus"></i></span>
                          Question
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
                <br/>
                <div *ngIf="questionnaire.questions.length>0" class="col-md-12 form-group questionnaireSection">
                  <div class="col-md-12">
                    <div *ngFor="let question of questionnaire.questions" class="row top-buffer">
                      <div class="col-md-12 question" >
                        <div>
                          <label>{{question.no}} ) {{question.texts.get(_selectedLanguage)}}</label>
                          <span style="margin-left: 10px; color:red;" (click)="onDeleteQuestion(question)" class="pull-right hand"><i class="fas fa-times"></i></span>
                        </div>
                        <div [ngSwitch]="question.type" style="padding-top:5px;padding-left:15px;">
                          <ng-container *ngSwitchCase="'combo'">
                              <span style="font-size: 18px;" class="pull-right hand"  (click)="onNewChoice(question)"><i class="far fa-plus-square"></i></span>
                              <label>Choice </label>
                            <div>
                              <select #Choices class="form-control" style="width: 70%;display:inline;">
                                    <ng-container *ngFor="let opt of question.choices">
                                        <option *ngIf="opt.texts.get(_selectedLanguage)!=null" [value]="opt.no">
                                            {{ opt.texts.get(_selectedLanguage)[0]}}
                                        </option>
                                    </ng-container>
                              </select>
                              <span style="font-size: 18px;" class="pull-right hand"  (click)="onNewChoice(question)"><i class="far fa-edit"></i></span>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'radio'">
                            <a #aEle  (click)="onNewChoice(question)" role="button">
                              <label>
                                <span style="font-size: 18px;"><i class="far fa-plus-square"></i></span>
                                Choice
                              </label>
                            </a>
                            <div *ngFor="let choice of question.choices" class="radio">
                              <label>
                                <input type="radio" [name]="question.no" [value]="choice.texts[_selectedLanguage]"/>
                                {{choice.texts.get(_selectedLanguage)}}
                              </label>
                              <span (click)="onDeleteChoice(question, choice)" class="pull-right hand"><i class="far fa-minus-square"></i></span>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'check'">
                            <!--<a #aEle  (click)="onNewChoice(question)" role="button">
                              <label>
                                <span style="font-size: 18px;"><i class="far fa-plus-square"></i></span>
                                Choice
                              </label>
                            </a>-->
                            <div *ngFor="let choice of question.choices" class="check">
                              <label>
                                <input type="checkbox" [name]="question.no" [value]="choice.texts[_selectedLanguage]"/>
                                {{choice.texts.get(_selectedLanguage)}}
                              </label>
                              <!--<span (click)="onDeleteChoice(question, choice)" class="pull-right hand"><i class="far fa-minus-square"></i></span>-->
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            <input type="text" class="form-control" readonly />
                          </ng-container>
                        </div>
                      </div>
                      <br/>
                    </div>
                    <br/>
                    <br/>
                  </div>
                </div>
                      </div>
                  </div>
                    <div class="col-md-12">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon3">Pivot Question</span>
                    </div>
                    <input type="number" min="0"  class="pivotQuestion form-control" id="basic-url" aria-describedby="basic-addon3"  (ngModelChange)="processPivot($event)" [(ngModel)]="questionnaire.pivotQuestion">
                  </div>
                  <div *ngIf="showPivotError" class="alert alert-danger pivotError">
                      <div>
                         Pivot question number should be greater than 0.
                      </div>
                  </div>

                  <div class="row top-buffer">
                    <div class="col-md-3">
                      <button type="button" style="margin-bottom:20px;" class="btn btn-primary" (click)="onUpdate()"><span style="margin-right:15px;"><i class="fas fa-save"></i></span>{{'save'|translate}}</button>
                    </div>
                  </div>
                </div>
                <footer class="w3-container w3-blue">
                  <h5></h5>
                </footer>
              </div>
              <!--</div>-->
            </div>
          </div>
       <!-- </div>
      </div>-->
<generic-info-modal  [hide]="_hideInfoModal" [title]="_genericModalTitle" [text]="_genericModalText" [statusCode]="_statusCode" (OkClick)="onOk()"></generic-info-modal>
<create-question-dialog [question]="_selected_question"  (OnNewQuestion)="addQuestion($event)" (OnCancelQuestion)="hideQuestionDialog()" [languages]="questionnaire.languages"></create-question-dialog>
<create-choice-dialog   (NewChoice)="addChoice($event)" (CancelChoice)="hideChoiceDialog()" [selectedLanguage]="_selectedLanguage"></create-choice-dialog>
<file-chooser [context]="_currentContext"></file-chooser>
<div *ngIf="project != null">
 <create-questionnaire-dialog #questionnaireDialog [project]="this.project" (StatusMessage)='showStatus($event)' [modalTitle]="_modalTitle" [placeholderText]="_placeHolderText" [terminal]="_terminal" [hide]="_hideQuestionnaireDialog" (NewQuestionnaire)="onComponentCreated($event)"></create-questionnaire-dialog>
</div>
<!--<add-file-to-download-dialog [hide]="_hideFileToDownloadDialog" [filesToDownload]="_fileToDownload" (on-new-file-to-download)="addFileToDownload($event)" (on-cancel-file-to-download)="hideFileToDownloadDialog()"></add-file-to-download-dialog>-->`
  ,styles: [
    `
            .tagsbox {
                width: 600px;
                border: 1px dashed #0d47a1;
                overflow-y: auto;
                float: left;
                margin-left: 0px;
                margin-top: 5px;
                margin-bottom: 5px;
                height: 50px;}
       .bold{font-weight: bold;}
      .pivotQuestion::-webkit-inner-spin-button,
      .pivotQuestion::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      .mainLogoIcon{width:100px;height:100px;margin-left: 15px;}
    .questionnaireSection  {
      border-style: dashed;
      border-color: #0067b8;
      border-radius: 5px;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .questionnaireFunction {
      border-style: dashed;
      border-color: #0067b8;
      border-radius: 5px;
      padding-top: 30px;
      padding-bottom: 30px;
    }
    .question{border-style:solid;
      border-color: #0067b8;
      border-radius: 5px;
      padding-top: 30px;
      padding-bottom: 30px;
      margin-bottom: 10px;}

    .langueSupporte{
      margin-left:40px;
    }
    .selectedLang{
      font-weight: bold;
      font-size: large;
    }

      .questionnaireDescription{
        border-style: dashed;
        border-color: #0067b8;
        border-radius: 5px;
        padding-top: 30px;
        padding-bottom: 30px;
      }
      .input-group-text {
          background: -webkit-linear-gradient(top, #648bf5, #2866f2);
          background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
          border-top: 1px solid #5a82eb;
          border-bottom: 1px solid #1758e7;
          color: #ffffff;
      }

      .card-header{ background-color:rgb(1,119,215);color:#ffffff;}
      .cardForm{border-color:#19A9E5;margin-top:30px;}
      .w3-container,.w3-panel{padding:0;}
      h4{text-align: center;color:#ffffff;margin-top:20px;}
      .col-md-12{margin-top: 30px;}
      .titleBar{height:24px;width:24px;margin-right:5px;}
      .titleBarIcon{height:40px;}

      .alert{font-weight: bold;color: red;font-size: 15px;margin-left:-20px;}
      .exclamation{margin-right:5px;}
    `]
})
export class QuestionnaireViewComponent implements OnChanges,OnInit {
    @Input('questionnaire') questionnaire: Questionnaire;
    @Input('project') project: Project;
    @Output() breadCrumbLink:EventEmitter<Project|Questionnaire|Terminal> = new EventEmitter();

    private showPivotError = false;

    private _currentContext:CurrentContext;

    private _selectedLanguage = '';


    private _modalTitle: string;
    private _placeHolderText: string;
    private _terminal: boolean;
    private _hideQuestionnaireDialog = true;

    private _selected_question: Question;
    // private _selected_choice: Choice;

    private _choice_types_to_clazz;

    private _emailFile:File = null;
    private _smsFile:File = null;
    private _pictureTransformationFile:File = null;
    private _hashTagSubscriptionFile:File = null;


    private _terminalID = 0;
    private _terminalName='';


    private _hideInfoModal = true;
    private _genericModalText: string;
    private _genericModalTitle: string;
    private _statusCode:number;

    // section purge
    public minDate: Date = new Date ('01/01/1979');
    public maxDate: Date = new Date ('01/01/2100');
    public startDateValue: Date = new Date (Date());
    public endDateValue: Date = new Date (Date());
    private startDate = '0'; // milliseconds in string representation
    private endDate = '0'; // milliseconds
    private purgeModel:PurgeModel;
    private purgeForm:FormGroup;

    @ViewChild (MaterialChipsInputComponent) materialTagChips:MaterialChipsInputComponent;
    @ViewChild (FileChooserComponent) private fileChooser:FileChooserComponent;
    @ViewChild (ImportDuplicateModalComponent) private importDuplicate:ImportDuplicateModalComponent;
    @ViewChild (CreateQuestionnaireComponent)  private childQuestionnaireDialog:CreateQuestionnaireComponent;
    @ViewChild (CreateQuestionComponent) private createQuestionDialog:CreateQuestionComponent;
    @ViewChild (CreateChoiceComponent) private createChoiceComponent:CreateChoiceComponent;
    constructor(private _formBuilder:FormBuilder, private _projectService: ProjectService, constants: Constants,private _deviceService: DeviceDetectorService, private _refreshService:SharedRefreshService) {
        this._choice_types_to_clazz = constants.CHOICE_TYPES_TO_CLAZZ;
    }

    ngOnInit() {
        this.setValidLanguages();
        this._currentContext = new CurrentContext();
        this._currentContext.project = this.project;
        this._currentContext.qId = this.questionnaire.id;
        this.materialTagChips.setLanguageArray(this.questionnaire.languages);
        this.materialTagChips.setSelectedLanguage(this.questionnaire.languages[0]);
        // this.materialTagChips.setId(this.emailLanguage);

        this._terminalName = this._deviceService.getDeviceInfo().device;
        switch(this._terminalName) {
            case 'unknown' : this._terminalID = 0;   // windows 10 based client(terminal)
                            break;
            case 'android' : this._terminalID = 1; // android based client(terminal)
                            break;
        }


        this.purgeForm = this._formBuilder.group({
                startDate: [],
                endDate: [],
                purgePeriod: ['', ValidationService.questionAndChoiceValidation],
                useDateRange: [false, null],
                unit:[],
                key:[],
                uei:[],
                extractListOfDeletedFiles:[]
            });


    }

    fileChange(type, event) {
        const fileList: FileList = event.target.files;
        if(fileList.length > 0) {
            const file: File = fileList[0];
            if (type === 'email') {
                this._emailFile = file;
            } else if (type === 'sms') {
                this._smsFile = file;
            } else if (type === 'picture') {
                this._pictureTransformationFile = file;
            } else if (type === 'hashtag') {
                this._hashTagSubscriptionFile = file;
            }
        }
    }

    getCronJobConfig() {
        this._projectService.getCronJob(this.project.id,this.questionnaire.id).subscribe((val)=> {

            this.purgeModel = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(val,PurgeModel);

            // could be false if purge has never been set on this questionnaire
            if(this.purgeModel == null) {
                this.purgeModel = new PurgeModel();
            }
            this.startDateValue = new Date(Number(this.purgeModel.purgeStartDate));
            this.endDateValue = new Date(Number(this.purgeModel.purgeEndDate));
            this.purgeForm.controls.purgePeriod.setValue(this.purgeModel.purgeCycle);
            this.purgeForm.controls.useDateRange.setValue(this.purgeModel.usePurgeDateRange);
            this.purgeForm.controls.uei.setValue(this.purgeModel.uei);
            this.purgeForm.controls.unit.setValue(this.purgeModel.unit);
            this.purgeForm.controls.extractListOfDeletedFiles.setValue(this.purgeModel.extractListOfDeletedFiles);

        });
    }


    onNewQuestion() {
        if (this.questionnaire.languages.length === 0) {
            // TODO show message
            alert('Add or select your questionnaire definition language from the supported languages.');
            return;
        }

        this._selected_question = new Question();
        this._selected_question.choices = [];
        this._selected_question.choices.push(new Choice());

        let i = 1;
        if(this.questionnaire.questions!=null && this.questionnaire.questions.length>0) {
            for (const question of this.questionnaire.questions) {
                // On recupere la derniere question pour determiner l'ordre numeral de la prochaine question
                if (i === this.questionnaire.questions.length) {
                    this._selected_question.no = question.no + 1;
                    break;
                }
                i++;

            }
        } else {
            if (isNaN( this._selected_question.no)) {
                this._selected_question.no =1;
            } else {
                this._selected_question.no = this._selected_question.no ++;
            }
        }


        this.createQuestionDialog.toggle();
    }

    onNewChoice(question:Question) {
        if (this.questionnaire.languages.length === 0) {
            // TODO show message
            return;
        }

        this._selected_question = question;
        // this._selected_choice = new Choice();
        this.createChoiceComponent.setChoiceArr(question.choices);
        this.createChoiceComponent.toggleModal();
    }

    onDeleteQuestion(question) {
        // TODO show message
        const index: number = this.questionnaire.questions.indexOf(question);
        if (index !== -1) {
            this.questionnaire.questions.splice(index, 1);
        }
    }

    onDeleteChoice(question:Question, choice) {
        // TODO show message
        const index: number = question.choices.indexOf(choice);
        if (index !== -1) {
            question.choices.splice(index, 1);
        }
    }

  onImport(src:any) {
    this.fileChooser.toggleFileChooser('projects');
    this.fileChooser.setTarget('questionnaire');
  }

  onDeleteComboChoice(choice:Choice, val) {
        // TODO show message
        choice.texts.get(this._selectedLanguage).splice(val.value-1,1);
        /*if (subChoices.value) {
            choice.subChoices.splice(subChoices.value -1 , 1);
        }*/
    }

    hideQuestionDialog() {
        this._selected_question = null;
        this.createQuestionDialog.toggle();
    }

    hideChoiceDialog() {
        this._selected_question = null;
        // this._selected_choice = null;
        this.createChoiceComponent.toggleModal();
    }

    addQuestion(question:Question) {
      console.log(question);
        const index: number = this.questionnaire.questions.indexOf(question);
        if (index === -1) {
            if (question.type === 'combo') {
                /*const c = new Choice();
                c.no = 1;
                c.clazz = this._choice_types_to_clazz[question.type];*/
                question.choices = [];
            }
            if(question.type==='sms') {
              this.questionnaire.sms = true;
            }
          if(question.type==='email') {
            this.questionnaire.email = true;
          }
            this.questionnaire.questions.push(question);
            console.log(this._selectedLanguage);
        }

        this.hideQuestionDialog();
    }

    addChoice(choice:Choice) {
        const index: number = this._selected_question.choices.indexOf(choice);
        if (index === -1) {
            console.log('add choice allo :'+this._selected_question.type);
            /*if (this._selected_question.type === 'combo') {

                 const sc:SubChoice = new SubChoice();

                 for(const key of choice.texts.keys()) {
                   sc.texts.set(key,choice.texts[key]);
                 }

                console.log( JSON.stringify(sc));

                sc.no =  this._selected_question.choices[0].subChoices.length + 1;
                this._selected_question.choices[0].subChoices.push(sc);
            } else {*/


          // choice.clazz = this._choice_types_to_clazz[this._selected_question.type];

                // console.log(this._selected_question);
                // choice.no =  this._selected_question.choices.length + 1;

               /*if(this._selected_question.choices.length === choice.no) {
                   this._selected_question.choices[choice.no-1].texts.set(this._selectedLanguage,choice.texts.get(this._selectedLanguage));
               } else {
                   this._selected_question.choices.push(choice);
               }*/
          // tslint:disable-next-line:triple-equals

                /*if(this._selected_question.choices.length===0) {
                  this._selected_question.choices.push(choice);
                } else {
                  this._selected_question.choices[0].texts.set(this._selectedLanguage,choice.texts.get(this._selectedLanguage));
                }*/
                console.log(JSON.stringify(choice));
                console.log(this._selectedLanguage);
                console.log(this._selected_question);
                console.log(JSON.stringify(this._selected_question.choices));
            // }
        }

        this.hideChoiceDialog();
    }


   onUpdate() {
        if(this.questionnaire.pivotQuestion === 0) {
            this.questionnaire.pivotQuestion = -1;
        }
        if (this.questionnaire.email) {
            if (this._emailFile != null) {
                this._projectService.uploadFile(this._emailFile , this.project.id, this.questionnaire.id).then(
                    msg => {
                        console.log(msg);
                    });
            }
        }

        this._projectService.updateQuestionnaire(this.questionnaire, this.project.id).subscribe(
            data => {
                if (data === 100) {
                this._statusCode = 200;
                this._genericModalText = 'Questionnaire Updated Successfully!';
                this._genericModalTitle = 'Questionnaire';
                this._hideInfoModal = false;
            }
            });
    }

    ngOnChanges() {
        this._selectedLanguage = this.questionnaire.languages[0];
        this.materialTagChips.setLanguageArray(this.questionnaire.languages);
        this.materialTagChips.setSelectedLanguage('');

        if(this._currentContext == null) {
          this._currentContext = new CurrentContext();
        }
      this._currentContext.project = this.project;
      this._currentContext.qId = this.questionnaire.id;
        this.getCronJobConfig();
    }

  onOk() {
    this._hideInfoModal = true;
    // location.reload(true);
     this._refreshService.refresh(true);
  }


  switchQuestionLanguage(lg: string) {
    this._selectedLanguage = lg;
    /*if(!this.questionnaire.languages.includes(lg)) {
      this.questionnaire.languages.push(lg);
    }*/
  }

  removeQuestionnaire() {
      // TODO: implement removal of a questionnaire from a project.
    this._projectService.removeQuestionnaire(this.questionnaire.id)
      .subscribe(data => {

          if(data === 200) {
              this._statusCode = 200;
              this._genericModalTitle = 'Questionnaire';
              this._genericModalText = 'Questionnaire has been successfully deleted.';
              this._hideInfoModal = false;
          } else if(data === 404) {
              this._statusCode = 301;
              this._genericModalTitle = 'Questionnaire';
              this._genericModalText = 'Questionnaire was not found. It was probably deleted.';
              this._hideInfoModal = false;
          } else if(data === 500) {
              this._statusCode = 301;
              this._genericModalTitle = 'Questionnaire';
              this._genericModalText = 'An internal exception has prevented from removing the questionnaire.';
              this._hideInfoModal = false;
          }
        },
        error => console.log('Error removing questionnaire'));
  }

  private generateBreadCrumb():(Project|Questionnaire|Terminal)[] {
    const crumbs:(Project|Questionnaire|Terminal)[] = [];

    crumbs.push(this.project);
    crumbs.push(this.questionnaire);

    return crumbs;
  }

  addTerminal() {
    this.childQuestionnaireDialog.generateQuestionnaireDropDownList();
    this.childQuestionnaireDialog.resetFields();
    this.childQuestionnaireDialog.generateTerminalTypeDropDown();
    this._modalTitle = 'New Terminal';
    this._placeHolderText = 'Terminal Questionnaire Title';
    this._terminal = true;
    this.childQuestionnaireDialog.hideDialog();
  }

  onBreadCrumbLink(node: Project | Questionnaire | Terminal) {
    this.breadCrumbLink.emit(node);
  }

  // TODO: Must improve by processing server replies. This has to be uniform anywhere there is a server communication.
  onComponentCreated(component: any) {
      console.log('questionnaire-view.component create');
    if(component instanceof Questionnaire) {
      this._statusCode = 200;
      this.project.questionnaires.push(component);
      this._genericModalText = 'Questionnaire has been successfully created!';
      this._genericModalTitle = 'Create Questionnaire';
      this._hideInfoModal = false;
    }
    if(component instanceof Terminal) {
      this._statusCode = 200;
      this.questionnaire.terminals.push(component);
      this._genericModalText = 'Terminal has been successfully created!';
      this._genericModalTitle = 'Create Terminal';
      this._hideInfoModal = false;
    } else if(component == null) {
        this._statusCode = 250;
        this._genericModalText = 'The intended object was not created. In case you were trying to created a terminal, make sure you did not enter a username that\'s been used by another terminal. Contact admin if this problem persists.';
        this._genericModalTitle = 'Create Object';
        this._hideInfoModal = false;
    }
  }

  showStatus(obj:StatusMsg) {
    this._hideInfoModal = false;
    this._genericModalText = obj.statusMsg;
    this._genericModalTitle = 'Terminal';
    this._statusCode = obj.httpStatusCode;
  }

  private isChecked():boolean {
      return this.questionnaire.fullScreen === true;
  }

  private setValidLanguages() {
        this.materialTagChips.setLanguageArray(this.questionnaire.languages);
  }

  private processPivot(pivotQuestion: number) {
        if(pivotQuestion<=0) {
            this.showPivotError = true;
            return;
        }
      this.showPivotError = false;
    }

  extractValue(strings: string[]):string {
        if(strings!=null) {
            return strings[0];
        }
        return null;
    }

    langAdded(lg: string) {
        if(lg!=='' && !this.questionnaire.languages.includes(lg)) {
            this.questionnaire.languages.push(lg);
        }
    }

    enableCronJob() {
        // this.purgeModel = new PurgeModel();
        this.purgeModel.purgeStartDate = this.startDate;
        this.purgeModel.purgeEndDate  =this.endDate;
        this.purgeModel.purgeCycle = Number(this.purgeForm.controls.purgePeriod.value);
        this.purgeModel.usePurgeDateRange = this.purgeForm.controls.useDateRange.value;
        this.purgeModel.uei = this.purgeForm.controls.uei.value;
        this.purgeModel.unit = this.purgeForm.controls.unit.value;
        this.purgeModel.extractListOfDeletedFiles = this.purgeForm.controls.extractListOfDeletedFiles.value;

        this._projectService.enableCronJob(this.project.id,this.questionnaire.id,this.purgeModel).subscribe((val)=> {
            if(val === true) {
                this._statusCode = 200;
                this._genericModalText = 'A cron job has been set on this questionnaire!';
                this._genericModalTitle = 'Questionnaire';
                this._hideInfoModal = false;
            }
        });
    }

    disableCronJob() {
        this._projectService.deleteCronJob(this.project.id,this.questionnaire.id).subscribe((val)=> {
            if(val === true) {
                this._statusCode = 200;
                this._genericModalText = 'A cron job has been removed from this questionnaire!';
                this._genericModalTitle = 'Questionnaire';
                this._hideInfoModal = false;
            }
        });
    }

    // purge section
    startDateChanged($event:any) {
        console.log($event);
        this.startDate =  $event.value.getTime().toString();
    }

    endDateChanged($event:any) {
        console.log($event);
        this.endDate =  $event.value.getTime().toString();
    }

    // obsolete
    onCheck($event: MouseEvent) {

    }

    addKey() {
        if(StringUtil.isEmptyOrNull(this.purgeForm['controls'].key.value)) {
            this._statusCode = 250;
            this._genericModalText = 'You cannot add an empty key';
            this._genericModalTitle = 'Project';
            this._hideInfoModal = false;
        } else {
            this.purgeModel.keys.push(this.purgeForm['controls'].key.value);
        }
    }

    removeKey(key: any) {
        const index = this.project.tags.indexOf(key);
        this.purgeModel.keys.splice(index,1);
    }
}
